<template>
  <a-box>
    <l-rows>
      <a-title
        size="4"
        :text="label"
      />
      <l-columns
        v-for="(property, index) in value"
        :key="index"
      >
        <m-input
          :label="$t('common.key')"
          :value="property.key"
          @input="handleKeyChange(property, $event)"
        />
        <m-input
          :label="$t('common.value')"
          :value="property.value"
          @input="handleValueChange(property, $event)"
        />
        <l-columns-column
          size="narrow"
          class="removePropertyButton"
        >
          <a-button
            type="button"
            icon-left="fas fa-trash"
            aria-label="Delete property"
            @click="handleRemoveProperty(index)"
          />
        </l-columns-column>
      </l-columns>
      <l-rows>
        <l-rows-row content-position="right">
          <a-button
            type="button"
            :text="this.$t('bridges.addProperty')"
            @click="handleAddProperty"
          />
        </l-rows-row>
      </l-rows>
    </l-rows>
  </a-box>
</template>

<script>
  import { MInput, AButton, ABox, ATitle, LColumns, LColumnsColumn, LRows, LRowsRow } from 'codefabrik-gui-vue'

  export default {
    name: 'CasinoProperties',
    components: { MInput, AButton, ABox, ATitle, LColumns, LColumnsColumn, LRows, LRowsRow },
    props: {
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      value: {
        type: Array,
        default: () => []
      },
      errorMessage: {
        type: String,
        default: null
      },
    },
    methods: {
      handleAddProperty () {
        this.value.push({ key: '', value: '' })
        this.$emit('input', this.value)
      },
      handleKeyChange (property, value) {
        property.key = value
        this.$emit('input', this.value)
      },
      handleValueChange (property, value) {
        property.value = value
        this.$emit('input', this.value)
      },
      handleRemoveProperty (index) {
        this.value.splice(index, 1)
        this.$emit('input', this.value)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/styles";

  .removePropertyButton {
    margin-top: auto;
  }
</style>
